module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - GED'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("GED")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ged"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "type": "button",
      "disabled": _vm.botaoAdicionarDocumento
    },
    nativeOn: {
      "click": function($event) {
        _vm.mostrarAdicionarDocumento = !_vm.mostrarAdicionarDocumento
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adicionar documento ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('upload-documento', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarAdicionarDocumento),
      expression: "mostrarAdicionarDocumento"
    }],
    attrs: {
      "documentTypes": '',
      "lista-projetos": _vm.projetos,
      "lista-entidades": _vm.entidades
    },
    on: {
      "mostrarQuadroAdicionaDocumento": function($event) {
        _vm.mostrarAdicionarDocumento = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        interactive: true,
        theme: 'light',
        position: 'top'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', position: 'top'}"
    }],
    staticClass: "col-md-1 legenda",
    attrs: {
      "title": '<table class=\'legenda_tabela\'>' +
        '<tr><td class=\'DEF\'><i class=\'fa fa-folder\'></i></td><td>Não contratado (ANA, DEF)</td></tr>' +
        '<tr><td class=\'APR\'><i class=\'fa fa-folder\'></i></td><td>Aprovado e regular (APR)</td></tr>' +
        '<tr><td class=\'SO3\'><i class=\'fa fa-folder\'></i></td><td>Aprovado e irregular (SO3, SO4, DLG, SPS etc)</td></tr>' +
        '<tr><td class=\'ENC\'><i class=\'fa fa-folder\'></i></td><td>Encerrado ou quase (ETO, ENC)</td></tr>' +
        '<tr><td style=\'color: #777\'><i class=\'fa fa-folder\'></i></td><td>Cancelado ou situação não definida</td></tr>' +
        '<tr><td class=\'text-bold\'>!</td><td>Informação não foi encontrada</td></tr>' +
        '</table>' +
        '<br/><br/>' +
        '<table class=\'legenda_tabela\'>' +
        '<tr><td>Liberação de recursos</td><td>Id ... Situação ... Valor total</td></tr>' +
        '<tr><td>Proposta</td><td>Início do projeto ... Duração dele</td></tr>' +
        '<tr><td>Dirigentes</td><td>Cargo ... Nome ... Mandato ... Situação</td></tr>' +
        '<tr><td>Entidade</td><td>CNPJ ... Razão Social</td></tr>' +
        '<tr><td>Relatório de Execução</td><td>Número ref. ... Situação ... apresentação ... aprovação</td></tr>' +
        '</table>' +
        '<br/><br/>' +
        '<table class=\'legenda_tabela\'>' +
        '<tr><td class=\'text-bold\'>Situação</td><td>&nbsp;</td></tr>' +
        '<tr><td class=\'text-bold text-right\'>  FEITO</td><td>Ação que foi concluída</td></tr>' +
        '<tr><td class=\'text-bold text-right\'>  EM_EXECUCAO</td><td>Ação que está em andamento</td></tr>' +
        '<tr><td class=\'text-bold text-right\'>  CANCELADO</td><td>Ação excluída/não processada</td></tr>' +
        '</table>' +
        '<br/><br/>' +
        '<table class=\'legenda_tabela\'>' +
        '<tr><td class=\'text-gray\'><i class=\'fa fa-refresh\'></i></td><td>Indica que pode clicar oara atualizar a pasta</td></tr>' +
        '<tr><td style=\'color: steelblue\'><i class=\'fa fa-download\'></i></td><td>Indica que pode fazer download do arquivo</td></tr>' +
        '<tr><td style=\'background:#b41904;\'>&nbsp;</td><td>Indica que a data de validade expirou</td></tr>' +
        '</table>'
    }
  }, [_vm._v("Legenda")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "arvore_projetos"
  }, [_c('li', {
    staticClass: "treeview",
    attrs: {
      "data-widget": "tree"
    }
  }, [_vm._m(1), _vm._v(" "), (!_vm._.isNil(_vm.projetos) && _vm.projetos.length > 0) ? _c('ul', {
    staticClass: "treeview-menu"
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('li', {
      staticClass: "treeview projeto",
      attrs: {
        "data-widget": "tree"
      },
      on: {
        "click": function($event) {
          return _vm.carregarPastas(projeto.id)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large',
          interactive: true,
          theme: 'dark',
          position: 'top'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
      }],
      class: 'fa fa-folder ' + projeto.situacao,
      attrs: {
        "title": '<h5>' + projeto.situacao + '</h5>'
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp + ' - ' + projeto.ds_nome))])]), _vm._v(" "), (!_vm._.isNil(projeto.pastas) && projeto.pastas.length > 0) ? _c('ul', {
      staticClass: "treeview-menu",
      staticStyle: {
        "display": "none"
      }
    }, _vm._l((projeto.pastas), function(pasta) {
      return _c('li', {
        staticClass: "treeview pasta",
        attrs: {
          "data-widget": "tree"
        },
        on: {
          "click": function($event) {
            return _vm.carregarArquivos(pasta.id, projeto.id, false)
          }
        }
      }, [_c('a', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'fade',
            distance: '1',
            size: 'large',
            interactive: true,
            theme: 'dark',
            position: 'top'
          }),
          expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
        }],
        attrs: {
          "href": "#",
          "title": "<h5>Clique para descobrir/buscar arquivos</h5>"
        }
      }, [_c('i', {
        class: 'fa ' + pasta.icone
      }), _vm._v(" "), _c('span', [_vm._v("\n                                " + _vm._s(pasta.nome) + "\n                                "), _c('span', {
        staticClass: "contador"
      }, [_vm._v("\n                                  " + _vm._s((_vm._.isNil(pasta.arquivos) ? '' : (pasta.arquivos.length > 0 ? pasta.arquivos.length + ' arquivo' + (pasta.arquivos.length > 1 ? 's' : '') : 'nenhum arquivo'))) + "\n                                  "), (!_vm._.isNil(pasta.arquivos)) ? _c('i', {
        staticClass: "fa fa-refresh",
        on: {
          "click": function($event) {
            return _vm.carregarArquivos(pasta.id, projeto.id, true)
          }
        }
      }) : _vm._e()])])]), _vm._v(" "), (!_vm._.isNil(pasta.arquivos) && pasta.arquivos.length > 0) ? _c('ul', {
        staticClass: "treeview-menu"
      }, _vm._l((_vm._.values(_vm._.groupBy(pasta.arquivos, 'grupo'))), function(agrupado) {
        return _c('li', {
          staticClass: "treeview pasta",
          attrs: {
            "data-widget": "tree"
          }
        }, [_c('a', {
          attrs: {
            "href": "#"
          }
        }, [_c('span', [_vm._v(_vm._s(agrupado[0].grupo) + "\n                                    "), _c('span', {
          staticClass: "contador"
        }, [_vm._v("\n                                    " + _vm._s((_vm._.isNil(agrupado) ? '' : (agrupado.length > 0 ? agrupado.length + ' arquivo' + (agrupado.length > 1 ? 's' : '') : 'nenhum arquivo'))) + "\n                                    "), (!_vm._.isNil(agrupado)) ? _c('i', {
          staticClass: "fa fa-external-link",
          on: {
            "click": function($event) {
              return _vm.irPara(agrupado[0].link)
            }
          }
        }) : _vm._e()])])]), _vm._v(" "), _c('ul', {
          staticClass: "treeview-menu",
          style: ('display: ' + (_vm._.values(_vm._.groupBy(pasta.arquivos, 'grupo')).length === 1 ? 'block' : 'none'))
        }, [_c('table', {
          staticClass: "arquivos"
        }, [_c('tbody', _vm._l((_vm._.sortBy(agrupado, 'ds_tipo')), function(arquivo) {
          return _c('tr', [_c('td', {
            style: (arquivo.ds_tipo.length > 57 ? 'width: 540px' : '')
          }, [_vm._v(_vm._s(arquivo.ds_tipo))]), _vm._v(" "), _c('td', [_c('a', {
            staticClass: "ng-binding",
            attrs: {
              "href": "javascript:void(0)"
            },
            on: {
              "click": function($event) {
                return _vm.onDownload(arquivo)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-download",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" " + _vm._s(arquivo.ds_nome_arquivo))])]), _vm._v(" "), _c('td', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'fade',
                distance: '1',
                size: 'large',
                interactive: true,
                theme: 'dark',
                position: 'top'
              }),
              expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
            }],
            staticClass: "data_incluido",
            attrs: {
              "title": _vm._.isNil(arquivo.incluido) ? '' : '<h6>Data de inclusão</h6>'
            }
          }, [_vm._v(_vm._s(arquivo.incluido))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'fade',
                distance: '1',
                size: 'large',
                interactive: true,
                theme: 'dark',
                position: 'top'
              }),
              expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'dark', position: 'top'}"
            }],
            class: 'data_validade ' + (_vm.dataExpirada(arquivo.validade) ? 'data_expirada' : ''),
            attrs: {
              "title": _vm._.isNil(arquivo.validade) ? '' : '<h6>Data de validade</h6>'
            }
          }, [_vm._v(_vm._s(arquivo.validade))])])
        }), 0)])])])
      }), 0) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0) : _vm._e()])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Consulta de Documentos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', [_vm._v("Projetos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f12480a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ged/ListaGed.vue
// module id = 2020
// module chunks = 2